import { Component, Input } from '@angular/core';
import { IDashboardItemDataLoaderLink } from 'src/app/services/dashboard-item/IDashboardItemDataLoaderLink';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';

@Component({
    selector: 'app-filter-selector',
    templateUrl: './filter-selector.component.html',
})
export class FilterSelectorComponent {
    @Input()
    filterDashboardItemLinks!: Partial<
        Record<DatasourceColumnId, IDashboardItemDataLoaderLink>
    >;

    values = Object.values;
}
